import type { ToggleGroupOption } from '@talos/kyoko';

/** Aggregation operation applied across the selected assets at each timestamp. */
export const AggregationMethod = { SUM: 'SUM', MEAN: 'MEAN' } as const;
export type AggregationMethod = (typeof AggregationMethod)[keyof typeof AggregationMethod];

/** Shared Sum/Mean toggle options — used by both the header toolbar and the config view. */
export const AGGREGATION_METHOD_OPTIONS: ToggleGroupOption<AggregationMethod>[] = [
  { value: AggregationMethod.SUM, displayName: 'Sum' },
  { value: AggregationMethod.MEAN, displayName: 'Mean' },
];

/**
 * Tab title used when the user hasn't customised one — derives from the active metric's
 * resolved display name so two panels with different metrics get distinct default titles.
 */
export function formatAggregatedMetricDefaultTitle(metricDisplayName: string): string {
  return `Aggregated ${metricDisplayName}`;
}

/**
 * Defaults baked into the panel-type registration. Per-panel-instance overrides
 * (metric, assets, aggregation, time range) live in `AggregatedMetricPanelConfig`
 * and are persisted to the layout config.
 */
export interface AggregatedMetricModuleConfig {
  /** CoinMetrics metric ID used when no persisted metric exists yet (e.g. `'CapMrktEstUSD'`). */
  defaultMetric: string;
  /** Seed asset selection used when no persisted selection exists yet. */
  defaultCmAssetIds: string[];
  defaultAggregationMethod: AggregationMethod;
  /** CoinMetrics frequency parameter (e.g. `'1d'`). */
  frequency: string;
  /** Static panel label shown in the add-panel menu and as the fallback chart title. */
  label: string;
}
